import { render, staticRenderFns } from "./ChannelTable.vue?vue&type=template&id=e861674c"
import script from "./ChannelTable.vue?vue&type=script&lang=js"
export * from "./ChannelTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports